module.exports = __webpack_public_path__ + "static/media/leftts.729b9618.png";